var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 20C17 18.3431 15.6569 17 14 17H10C8.34315 17 7 18.3431 7 20M21 17.0004C21 15.7702 20.0372 14.7596 18.8333 14.6155M3 17.0004C3 15.7702 3.96281 14.7596 5.16667 14.6155M15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11ZM19.5 9C19.5 10.1046 18.6046 11 17.5 11C16.3954 11 15.5 10.1046 15.5 9C15.5 7.89543 16.3954 7 17.5 7C18.6046 7 19.5 7.89543 19.5 9ZM8.5 9C8.5 10.1046 7.60457 11 6.5 11C5.39543 11 4.5 10.1046 4.5 9C4.5 7.89543 5.39543 7 6.5 7C7.60457 7 8.5 7.89543 8.5 9Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllUsers);
export default __webpack_public_path__ + "static/media/allUsers.2900c0f9f1311558770caee7a3b4395b.svg";
export { ForwardRef as ReactComponent };